import { SOWChange } from '@/types';

interface ChangeHistoryProps {
  changes: SOWChange[];
  onAcknowledge?: (changeId: string) => void;
  showAcknowledgeButton?: boolean;
}

export function ChangeHistory({
  changes,
  onAcknowledge,
  showAcknowledgeButton = false,
}: ChangeHistoryProps) {
  return (
    <div className="space-y-3">
      <h2 className="text-xl font-bold text-gray-900">Change History</h2>
      {changes.length === 0 ? (
        <p className="text-gray-500">No changes recorded yet.</p>
      ) : (
        changes.map((change) => (
          <div
            key={change.id}
            className="bg-white p-4 rounded-lg shadow border-l-4 border-blue-500"
          >
            <div className="flex justify-between items-start">
              <div>
                <span className="inline-block px-2 py-1 text-xs font-semibold rounded bg-blue-100 text-blue-800">
                  {change.changeType.toUpperCase()}
                </span>
                <p className="mt-2 text-gray-700">
                  {change.description || 'No description'}
                </p>
                <p className="mt-1 text-sm text-gray-500">
                  {new Date(change.createdAt).toLocaleString()} by {change.actor}
                </p>
              </div>
              <div>
                {change.acknowledged ? (
                  <span className="text-green-600 text-sm">✓ Acknowledged</span>
                ) : showAcknowledgeButton ? (
                  <button
                    onClick={() => onAcknowledge?.(change.id)}
                    className="bg-green-600 text-white px-3 py-1 rounded text-sm hover:bg-green-700"
                  >
                    Acknowledge
                  </button>
                ) : (
                  <span className="text-gray-400 text-sm">Not acknowledged</span>
                )}
              </div>
            </div>
          </div>
        ))
      )}
    </div>
  );
}
